import { AllegatoDto, SoggettoDto } from "@api/client";
import {
	contractDownloadContract,
	contractGenerateContracts,
	contractGetOtp,
	contractSignContract,
} from "common/_redux/contract/actions";
import { subjectGetDetails, subjectSetTitolariEffettiviAdded } from "common/_redux/subject/actions";
import { legaleRappresentanteSelector } from "common/_redux/subject/selectors";
import BftAccordion from "common/components/accordion";
import BftButton from "common/components/button";
import DettaglioPianoCard from "common/components/dettaglio-piano-card";
import OtpModal from "common/components/otp-modal";
import RiepilogoTitolariCard from "common/components/riepilogo-titolari";
import { FirmaSchema } from "common/validators/validators";
import { authLogout } from "core/auth/_redux/action";
import { AppRouterService } from "core/routes/app-router.service";
import { PathEnum } from "core/routes/path.enum";
import { useAppDispatch, useAppSelector } from "core/store/hooks";
import { Formik, FormikProps } from "formik";
import Header from "layout/components/header";
import SideBar from "layout/components/sidebar";
import Topbar from "layout/components/topbar";
import { useEffect, useRef, useState } from "react";
import { Card, Col, Form, Modal, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { AllegatoCheckDownload } from "../step-6/models";
import "./style.scss";

const title = "7. Firma";
const subtitle = "Sottoscrivi la proposta dopo averne controllato il contenuto.";

const SeventhStepPage: React.FC = () => {
	const dispatch = useAppDispatch();
	const navigate = useNavigate();

	const formRef = useRef<FormikProps<InitialValues>>(null);

	const legaleRappresentante = useAppSelector(legaleRappresentanteSelector);

	const [contratti, setContratti] = useState<AllegatoDto[]>();
	const [contrattiMapped, setContrattiMapped] = useState<AllegatoCheckDownload[]>();
	const [showNormeModal, setShowNormeModal] = useState(false);
	const [showOtp, setShowOtp] = useState(false);

	const [showModalTitolariUncomplete, setShowModalTitolariUncomplete] = useState(false);
	const [errorMessage, setErrorMessage] = useState("");

	const navBack = () => {
		navigate(-1);
	};

	const goNext = () => {
		navigate(AppRouterService.get(PathEnum.processoTerminato));
	};

	const goToHomePage = () => {
		dispatch(authLogout());

		window.location.href = "https://buffettifinance.com/";
	};

	const handleOpenNormeModal = () => {
		setShowNormeModal(true);
	};

	const handleCloseNormeModal = () => {
		setShowNormeModal(false);
	};

	const handleOpenFile = (allegato: AllegatoDto) => {
		if (!allegato.idAllegato) throw "idAllegato not found";

		dispatch(
			contractDownloadContract({
				elencoIdAllegati: [allegato.idAllegato],
				merged: true,
			})
		)
			.unwrap()
			.then((res) => {
				if (res) {
					// const blobUrl = URL.createObjectURL(res);
					// const link = document.createElement("a");
					// link.href = blobUrl;
					// link.download = allegato.nomeFile || "contratto";
					// link.click();
					// URL.revokeObjectURL(blobUrl);
					setContrattiMapped((prev) => {
						return prev?.map((c) => {
							if (c.idAllegato == allegato.idAllegato) c.downloaded = true;
							return c;
						});
					});
				}
			});
	};

	const handleDownloadAll = (allegato: AllegatoDto) => {
		if (!allegato.idAllegato) throw "idAllegato not found";
		if (contratti) {
			const elencoIdAllegati = contratti
				.map((contratto) => contratto.idAllegato)
				.filter((id) => typeof id === "string") as string[];

			dispatch(
				contractDownloadContract({
					elencoIdAllegati,
					merged: true,
				})
			)
				.unwrap()
				.then((res) => {
					if (res) {
						setContrattiMapped((prev) => {
							return prev?.map((c) => {
								if (c.idAllegato == allegato.idAllegato) {
									let contrattoScaricato = { ...c };
									contrattoScaricato.downloaded = true;
									// console.log("contrattoScaricato", contrattoScaricato.downloaded);
									return contrattoScaricato;
								} else {
									return c;
								}
							});
						});
					}
				});
		}
	};

	const handleSubmit = () => {
		if (!contrattiMapped || !contrattiMapped[0]?.downloaded) {
			return;
		}

		getOtp();
	};

	const getOtp = () => {
		dispatch(contractGetOtp())
			.unwrap()
			.then((res) => {
				if (res) setShowOtp(true);
			});
	};

	const signContract = (otp: string) => {
		dispatch(contractSignContract(otp))
			.unwrap()
			.then((res) => {
				if (res) {
					setShowOtp(false);
					goNext();
				}
			});
	};

	const generateContracts = () => {
		dispatch(contractGenerateContracts())
			.unwrap()
			.then(async (res) => {
				if (res?.allegati) {
					setContratti(res.allegati);
				}
			})
			.catch((error) => {
				setErrorMessage(error.message);
				setShowModalTitolariUncomplete(true);
			});
	};

	const getSubjects = () => {
		dispatch(subjectGetDetails())
			.unwrap()
			.then((subjectRes) => {
				if (subjectRes?.elencoTitolariEffettivi?.length) {
					const esponentiMapped = subjectRes.elencoTitolariEffettivi?.map((item: SoggettoDto) => ({
						...item,
						idFE: item.id,
						fulfilled: item.fullfiled,
					}));
					dispatch(
						subjectSetTitolariEffettiviAdded({
							list: esponentiMapped,
						})
					);
				}
			});
	};

	useEffect(() => {
		generateContracts();
	}, []);

	useEffect(() => {
		setContrattiMapped(
			contratti?.map((c) => c as AllegatoCheckDownload)?.map((c) => ({ ...c, downloaded: false }))
		);
	}, [contratti]);

	// useEffect(() => {
	// 	formRef.current?.setFieldValue(
	// 		"documentsDownloaded",
	// 		contrattiMapped?.every((c) => c.downloaded)
	// 	);
	// }, [contrattiMapped]);

	useEffect(() => {
		if (!legaleRappresentante) getSubjects();
	}, [legaleRappresentante]);

	return (
		<>
			<div>
				<SideBar />
				<div className="wrapper d-flex flex-column min-vh-100">
					<div className="body flex-grow-1 px-0">
						<Header />
						<Topbar />
						<div className="container-fluid body-section px-0">
							<section>
								<Row>
									<Col sm={12} lg={8}>
										<div>
											<h2 className="mb-3 ms-3">{title}</h2>
											<span className="gray">{subtitle}</span>
										</div>

										<BftAccordion title="Firma contratto" index={1} total={1} isActive>
											<div className="firma-contratto container">
												<div className="my-2">
													<h5 className="mb-2">Ok, ci siamo quasi!</h5>
													<p>
														Prima di procedere alla sottoscrizione del contratto, leggi attentamente
														il documento allegato.
													</p>
												</div>

												<div className="container">
													<div>
														<Formik
															innerRef={formRef}
															initialValues={{
																documentazione: false,
																norme: false,
																documentsDownloaded: true,
															}}
															onSubmit={handleSubmit}
															validationSchema={FirmaSchema}
														>
															{({
																values,
																errors,
																handleBlur,
																handleChange,
																handleSubmit: _handleSubmit,
																touched,
															}) => (
																<>
																	{contrattiMapped && (
																		<Card
																			key={`contratto`}
																			className={`shadow mx-0 ${
																				touched.documentsDownloaded
																					? contrattiMapped[0]?.downloaded
																						? "is-downloaded"
																						: "is-not-downloaded"
																					: ""
																			}`}
																		>
																			<Card.Body className="d-flex align-items-center justify-content-between">
																				<div>
																					<h5>Contratto</h5>
																					<p className="mt-3">Il tuo kit contrattuale</p>
																				</div>
																				<div
																					className="open-pdf-btn"
																					role="button"
																					onClick={() => handleDownloadAll(contrattiMapped[0])}
																				>
																					<i className="rounded-circle border p-3 mx-3 mb-2" />
																					<div className="text-primary text-weight-bold">
																						Apri PDF
																					</div>
																				</div>
																			</Card.Body>
																		</Card>
																	)}

																	<hr />

																	<form onSubmit={_handleSubmit}>
																		<Form.Check
																			type="checkbox"
																			className="p-3 pt-2 pb-2"
																			name="documentazione"
																			label="Approvo la documentazione contrattuale sopra indicata"
																			isInvalid={!!errors.documentazione && touched.documentazione}
																			feedbackType="invalid"
																			checked={values.documentazione}
																			onChange={handleChange}
																			onBlur={handleBlur}
																		/>
																		{errors.documentazione && touched.documentazione && (
																			<Form.Control.Feedback className="ms-3" type="invalid">
																				{errors.documentazione}
																			</Form.Control.Feedback>
																		)}

																		<Form.Check
																			type="checkbox"
																			className="p-3 pt-1 pb-2"
																			name="norme"
																			label="Approvo specificatamente le norme ai sensi degli articoli 1341 e 1342 del c.c. e del Testo Unico Bancario"
																			isInvalid={!!errors.norme && touched.norme}
																			feedbackType="invalid"
																			checked={values.norme}
																			onChange={handleChange}
																			onBlur={handleBlur}
																		/>
																		{errors.norme && touched.norme && (
																			<Form.Control.Feedback className="ms-3" type="invalid">
																				{errors.norme}
																			</Form.Control.Feedback>
																		)}

																		<a
																			className="ms-3 text-primary fw-semibold my-1 text-decoration-none"
																			role="button"
																			onClick={handleOpenNormeModal}
																		>
																			NORME DA APPROVARE
																		</a>

																		<div className="d-flex align-items-center">
																			<i className="fa-solid fa-triangle-exclamation"></i>
																			<Form.Control.Feedback className="ms-3 my-3" type="invalid">
																				Scarica il Contratto
																			</Form.Control.Feedback>
																		</div>

																		<div className="mt-3">
																			<BftButton
																				type="submit"
																				className="col-12 text-bg-dark border-0"
																			>
																				Avanti
																			</BftButton>
																		</div>
																	</form>
																</>
															)}
														</Formik>
													</div>
												</div>
											</div>
										</BftAccordion>

										<Row className="justify-content-between mx-1">
											<Col xs={1}>
												<BftButton
													className="btn-buffetti-secondary px-3"
													onClick={() => navBack()}
												>
													<i className="fas fa-arrow-left"></i>
												</BftButton>
											</Col>
										</Row>
									</Col>
									<Col sm={12} md={4} className="side-card">
										<DettaglioPianoCard />
										<RiepilogoTitolariCard />
									</Col>
								</Row>
							</section>
						</div>
					</div>
				</div>
			</div>

			<OtpModal
				show={showOtp}
				message={
					<p className="container text-center">
						Abbiamo inviato un codice al tuo numero di telefono{" "}
						<p className="fw-bold">
							{legaleRappresentante?.prefissoTel} {legaleRappresentante?.numeroTel}
						</p>
						Per completare il processo di firma inserisci il codice.
					</p>
				}
				type="sms"
				onSubmit={signContract}
				handleClose={() => setShowOtp(false)}
				onResend={getOtp}
			/>

			<Modal show={showNormeModal} onHide={handleCloseNormeModal} className="modal-lg">
				<Modal.Header closeButton>
					<Modal.Title>Contratto di Convenzionamento</Modal.Title>
				</Modal.Header>

				<Modal.Body>
					<b>Articolo 2</b> – Oggetto del Contratto di Convenzionamento;
					<br />
					<b>Articolo 3</b> - Richiesta di Convenzionamento, abilitazione e attivazione del
					Merchant, efficacia del Contratto di Convenzionamento e definizione delle condizioni
					economiche;
					<br />
					<b>Articolo 4</b> – Disposizioni applicabili ai Servizi;
					<br />
					<b>Articolo 5</b> – Utilizzo dei Terminali POS e degli altri Strumenti Tecnologici;
					<br />
					<b>Articolo 6</b> – Accettazione delle Carte;
					<br />
					<b>Articolo 7</b> – Autorizzazione;
					<br />
					<b>Articolo 8</b> – Rimborsi;
					<br />
					<b>Articolo 9</b> – Presentazione e prova delle Transazioni;
					<br />
					<b>Articolo 10</b> - Pagamenti in favore del Merchant e diritto dell’Acquirer di disporre
					sospensioni e storni di accrediti e diritto del Prestatore di Servizi di Pagamento di
					disporre sospensioni dei Servizi;
					<br />
					<b>Articolo 11</b> – Importi dovuti dal Merchant;
					<br />
					<b>Articolo 12</b> – Informativa periodica;
					<br />
					<b>Articolo 13</b> – Storni e Rettifiche;
					<br />
					<b>Articolo 14</b> – Obblighi del Merchant;
					<br />
					<b>Articolo 15</b> – Contestazioni dei titolari di Carta;
					<br />
					<b>Articolo 16</b> – Responsabilità;
					<br />
					<b>Articolo 17</b> – Insoluti, compensazioni e garanzie;
					<br />
					<b>Articolo 18</b> – Riservatezza;
					<br />
					<b>Articolo 19</b> - Utilizzo delle informazioni e trattamento dei dati dei Titolari di
					Carta;
					<br />
					<b>Articolo 20</b> – Durata, Recesso e Risoluzione del Contratto di Convenzionamento;
					<br />
					<b>Articolo 21</b> – Cessione del Contratto di Convenzionamento e dei relativi diritti ed
					obblighi;
					<br />
					<b>Articolo 22</b> – Incaricati e subcontraenti;
					<br />
					<b>Articolo 23</b> – Modifiche al Contratto di Convenzionamento;
					<br />
					<b>Articolo 24</b>– Reclami;
					<br />
					<b>Articolo 26</b> – Miscellanea.
				</Modal.Body>
			</Modal>

			<Modal
				show={showModalTitolariUncomplete}
				onHide={() => setShowModalTitolariUncomplete(false)}
				centered
			>
				<Modal.Header closeButton>
					<Modal.Title>Alcuni campi mancanti</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="d-flex flex-column">
						{errorMessage === "Iban non presente" ? (
							<div>
								<span>
									Gentile cliente, per procedere alla firma del contratto mancano i seguenti dati:
								</span>
								<br />
								<span className="fw-bold">- {errorMessage}</span>
								<br />
								<span>
									Si prega di tornare indietro nel processo e valorizzare i campi mancanti.
								</span>
							</div>
						) : (
							<span>{errorMessage}</span>
						)}
					</div>
				</Modal.Body>
			</Modal>
		</>
	);
};
export default SeventhStepPage;

interface InitialValues {
	documentazione: boolean;
	norme: boolean;
	documentsDownloaded: boolean;
}
